import "@/App.css";
import { useEffect } from "react";
import { BrowserRouter, Routes, Route, useParams } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import PatientChat from "@/pages/PatientChat";
import AdminDashboard from "@/pages/AdminDashboard";

const ContactRedirect = () => {
  const { code } = useParams();
  useEffect(() => {
    window.location.replace(`${process.env.REACT_APP_BACKEND_URL}/api/c/${code || "whatsapp"}`);
  }, [code]);
  return null;
};

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<PatientChat />} />
        <Route path="/widget" element={<PatientChat widget />} />
        <Route path="/admin" element={<AdminDashboard />} />
        <Route path="/c/:code" element={<ContactRedirect />} />
        <Route path="/wa" element={<ContactRedirect />} />
      </Routes>
      <Toaster position="top-center" richColors />
    </BrowserRouter>
  );
}

export default App;
